import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  exportedDataTitle: {
    id: 'course-authoring.export.footer.exportedData.title',
    defaultMessage: 'Data exported with your course:',
  },
  exportedDataItem1: {
    id: 'course-authoring.export.footer.exportedData.item.1',
    defaultMessage: 'Values from Advanced settings, including MATLAB API keys and LTI passports',
  },
  exportedDataItem2: {
    id: 'course-authoring.export.footer.exportedData.item.2',
    defaultMessage: 'Course content (all sections, sub-sections, and units)',
  },
  exportedDataItem3: {
    id: 'course-authoring.export.footer.exportedData.item.3',
    defaultMessage: 'Course structure',
  },
  exportedDataItem4: {
    id: 'course-authoring.export.footer.exportedData.item.4',
    defaultMessage: 'Individual problems',
  },
  exportedDataItem5: {
    id: 'course-authoring.export.footer.exportedData.item.5',
    defaultMessage: 'Pages',
  },
  exportedDataItem6: {
    id: 'course-authoring.export.footer.exportedData.item.6',
    defaultMessage: 'Course assets',
  },
  exportedDataItem7: {
    id: 'course-authoring.export.footer.exportedData.item.7',
    defaultMessage: 'Course settings',
  },
  notExportedDataTitle: {
    id: 'course-authoring.export.footer.notExportedData.title',
    defaultMessage: 'Data not exported with your course:',
  },
  notExportedDataItem1: {
    id: 'course-authoring.export.footer.notExportedData.item.1',
    defaultMessage: 'User data',
  },
  notExportedDataItem2: {
    id: 'course-authoring.export.footer.notExportedData.item.2',
    defaultMessage: 'Course team data',
  },
  notExportedDataItem3: {
    id: 'course-authoring.export.footer.notExportedData.item.3',
    defaultMessage: 'Forum/discussion data',
  },
  notExportedDataItem4: {
    id: 'course-authoring.export.footer.notExportedData.item.4',
    defaultMessage: 'Certificates',
  },
});

export default messages;
